export enum StatusRisk {
	DEFAULT,
	ACCEPTABLE,
	HIGH_RISK
}
